import { TipoTransaccion } from '@models/config.model';
import { ConfigurationState, InitialData } from '../../store/models/store.model';
import { InstallationCodeResponse } from '../../models/installation.model';
import { ActualUser } from '../../models/user.model';
import { Action } from '@ngrx/store';

export const SETINSTALLATIONCODE =
    '[configuration] Se setea el codigo de instalacion';

export const SETCONFIGURATIONDATA =
    '[configuration] Se agregan datos de configuracion';

export const REMOVEUSERDATA =
    '[configuration] Se remueven datos del usuario';

export const REMOVEINSTALLATIONCODE =
    '[configuration] Se remueven datos del codigo de instalacion del sistema';

export const REMOVECONFIGURATIONDATA =
    '[configuration] Se remueven datos de configuracion';

export const SETACTIVEUSER = '[configuration] Set usuario activo';

export const SETINITIALDATA = '[configuration] Set datos iniciales';

export const UNSETINITIALDATA = '[configuration] Unset datos iniciales';

export const SETTIPOTRANSACCIONDATA =
    '[configuration] Set datos de transacciones';

export const SETPRESCRIPTIONDATA =
    '[configuration] Set datos de prescripciones';

export const SETUSERCONFIGURATION =
    '[configuration] Set configuracion usuario';

export const UNSETUSERCONFIGURATION =
    '[configuration] Unset configuracion usuario';

export const UNSETCONFIGURATION = '[configuration] Unset configuracion';

export const SETNEWTOKEN = '[configuration] Set nuevo token';

export class SetInstallationCode implements Action {
    readonly type = SETINSTALLATIONCODE;
    constructor(public installationCodes: Array<InstallationCodeResponse>) { }
}

export class SetActualUser implements Action {
    readonly type = SETACTIVEUSER;
    constructor(public actualUser: ActualUser) { }
}

export class SetConfigurationData implements Action {
    readonly type = SETCONFIGURATIONDATA;
    constructor(public configurationData: ConfigurationState) { }
}

export class RemoveInstallationCode implements Action {
    readonly type = REMOVEINSTALLATIONCODE;

    constructor(public installationCode: string) { }
}

export class RemoveUserData implements Action {
    readonly type = REMOVEUSERDATA;
}

export class RemoveConfigurationData implements Action {
    readonly type = REMOVECONFIGURATIONDATA;
}

export class SetNewToken implements Action {
    readonly type = SETNEWTOKEN;
    constructor(public newToken: string) { }
}

export class SetInitialData implements Action {
    readonly type = SETINITIALDATA;
    constructor(public initialData: InitialData) { }
}

export class UnsetInitialData implements Action {
    readonly type = UNSETINITIALDATA;
}

export class SetTipoTransaccionData implements Action {
    readonly type = SETTIPOTRANSACCIONDATA;
    constructor(public TipoTransaccion: Array<TipoTransaccion>) { }
}

export class SetPrescriptionData implements Action {
    readonly type = SETPRESCRIPTIONDATA;
    constructor(public prescripcionTypes: Array<TipoTransaccion>) { }
}

export class UnsetConfiguration implements Action {
    readonly type = UNSETCONFIGURATION;
}

export type configurationActions =
    | SetInstallationCode
    | RemoveConfigurationData
    | SetActualUser
    | SetConfigurationData
    | RemoveUserData
    | SetNewToken
    | RemoveInstallationCode
    | SetInitialData
    | UnsetInitialData
    | SetTipoTransaccionData
    | SetPrescriptionData
    | UnsetConfiguration;
